module.exports = __webpack_public_path__ + "img/share_list2.4ac93010.png";